import {OrderForm} from '@yandex-delivery/order-form/index@desktop'
import type {ReactElement} from 'react'
import React from 'react'

import {experiments} from 'src/shared/config'
import {BusinessToggle} from 'src/widgets/BusinessToggle/BusinessToggle'
import {Verticals} from 'src/widgets/VerticalsDeprecated/Verticals'

import {Names} from './consts'
import {useOrderForm} from './hooks/useOrderForm'

export default function OrderFormBdui(): ReactElement {
  const formProps = useOrderForm()

  return (
    <>
      <OrderForm {...formProps}>
        <Verticals name={Names.VERTICALS} showAdditions={false}>
          {experiments.isBusinessToggleVisible && <BusinessToggle name={Names.BUSINESS_TOGGLE} />}
        </Verticals>
      </OrderForm>
    </>
  )
}
